import * as JsSearch from "js-search"

export const buildPostFromNode = node => ({
  ...node.frontmatter,
  ...node.fields,
  id: node.id,
  body: node.body,
})

export const initializeJsSearch = edges => {
  const instance = new JsSearch.Search("id")

  instance.indexStrategy = new JsSearch.PrefixIndexStrategy()
  instance.sanitizer = new JsSearch.LowerCaseSanitizer()
  instance.searchIndex = new JsSearch.TfIdfSearchIndex("id")

  const searchableData = edges.map(({ node }) => buildPostFromNode(node))

  instance.addDocuments(searchableData)
  instance.addIndex("title")
  instance.addIndex("author")
  instance.addIndex("date")
  instance.addIndex("body")

  return instance
}
